import styled from 'styled-components'

export const Error = styled.span`
position: absolute;
color: red;
font-weight: 500;
font-size: 12px;
line-height: 150%;
left: 0;
top: calc(100% + 10px);
`;

export default Error;
